export default __webpack_public_path__ + "ass-name.svg";